import { render, staticRenderFns } from "./ArticleTitleRow.vue?vue&type=template&id=4ce9ceff&scoped=true"
import script from "./ArticleTitleRow.vue?vue&type=script&lang=js"
export * from "./ArticleTitleRow.vue?vue&type=script&lang=js"
import style0 from "./ArticleTitleRow.vue?vue&type=style&index=0&id=4ce9ceff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9ceff",
  null
  
)

export default component.exports